//
// Project home: https://github.com/jaxio/celerio-angular-quickstart
// 
// Source code generated by Celerio, an Open Source code generator by Jaxio.
// Documentation: http://www.jaxio.com/documentation/celerio/
// Source code: https://github.com/jaxio/celerio/
// Follow us on twitter: @jaxiosoft
// This header can be customized in Celerio conf...
// Template pack-angular:web/src/app/support/paging.ts.p.vm
//
import {LazyLoadEvent} from 'primeng/primeng';

export class PageResponse<E> {
    constructor(public totalPages : number,
                public totalElements : number,
                public content : E[]) { }

    // remove the passed element from the content array.
    remove(element : E) {
        let indexToRemove : number = this.content.indexOf(element);
        this.content.splice(indexToRemove, 1);
        this.totalElements = this.totalElements - 1;
    }
}

export class PageRequestByExample<E> {
    public first: number;
    public rows: number;    
    constructor(public example : E,
                public lazyLoadEvent : LazyLoadEvent) {
                    this.first = lazyLoadEvent.first;
                    this.rows = lazyLoadEvent.rows;
                }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/pagingNormal.ts